import { useState } from 'react'

export const formatDateValue = (dateValue, mode, fallback = null) => {
  if (!dateValue && !fallback) {
    return ''
  }

  const guardedDateValue = dateValue ? new Date(dateValue) : fallback

  const dateFormater = {
    'toYYYY-MM-DD': guardedDateValue.toISOString().substring(0, 10),
    toISO: guardedDateValue.toISOString()
  }

  return dateFormater[mode] || dateFormater['toISO']
}

const FormikDatePicker = ({ className, name, value, setFieldValue }) => {
  const [dateFildValue, setDateFieldValue] = useState(
    value ? formatDateValue(value, 'toYYYY-MM-DD') : null
  )

  const handleDateChange = e => {
    const dateTextBoxValue = e.target.value
    setDateFieldValue(formatDateValue(dateTextBoxValue, 'toYYYY-MM-DD'))
    setFieldValue(name, formatDateValue(dateTextBoxValue, 'toISO'))
  }

  return (
    <input
      className={className}
      type='date'
      value={dateFildValue}
      onChange={handleDateChange}
    />
  )
}

export default FormikDatePicker
